var map = {
	"./scratch-bg.png": 106,
	"./scratch-bg@2x.png": 107
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 197;



//////////////////
// WEBPACK FOOTER
// ./themes/mf/img ^\.\/scratch\-bg.*\.png$
// module id = 197
// module chunks = 3